import { ajax } from '../../utils/fetch';

import { statusMsg, textEditor, htmlTrim, autoResize } from '../../utils/utils';

const templateAboutUS = document.createElement('template');

templateAboutUS.innerHTML = `<section class="about container secondary-bg mh-a">
                             <span class="au-dot top-left"></span>
                             <div class="fx heading">
                                    <h2 class="title">About Us</h2>
                                                             <div class="ml-a noedit">
                                                                 <button class="link link-accept start-edit">Edit</button>
                                                                 <div class="editing">
                                                                 <button class="link link-accept save">Save</button>
                                                                 <button class="link link-reject cancel">Cancel</button>
                                                                 </div>
                                                             </div>
                                                             </div>
                                                             <div class="about-editor editable hide">
                                                             <div class="text-editor"  data-gramm_editor="true" ondragover="return false;"></div>
                                                             </div>
                                                             <p class="text about-display" data-placeholder ="Tell us about yourselves"></p>
                                                         </section> <div class="courses"></div>`;

export default class LandingAboutUs extends HTMLElement {
  static get observedAttributes() {
    return ['semanticname', 'mode'];
  }

  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  connectedCallback() {
    this.appendChild(templateAboutUS.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal) this._renderAboutUs(this._aboutUs);
    if (name === 'mode' && newVal && newVal === 'edit') this._bindEvents();
  }

  _renderAboutUs(description) {
    if (description) {
      this.querySelector('.about-display').innerHTML = description;
    }
  }

  async _saveAboutUs() {
    try {
      const description = htmlTrim(this.querySelector('.ql-editor'));

      const univDTO = {
        description,
        semanticName: this.getAttribute('semanticname')
      };

      statusMsg('Saving ...');

      const univDesc = {};

      univDesc.contentType = 'application/json; charset=utf-8';
      univDesc.method = 'PATCH';
      univDesc.url = `/api/v1/university/${this.getAttribute(
        'semanticname'
      )}/description`;
      univDesc.body = univDTO;

      const response = await ajax(univDesc);
      if (response && response.status) {
        statusMsg(response.msg);
      }
    } catch (e) {
      console.error(`Error while saving about us :: ${e.message}`);
    }
  }

  _bindEvents() {
    const aboutUsEditor = this.querySelector('.text-editor');
    textEditor(aboutUsEditor, 'Enter description of the university here...');

    this._mapQlEditorKeyBindings(aboutUsEditor);

    this.querySelector('.save').addEventListener('click', () => {
      this._saveAboutUs();

      this._addOrRemoveEditMode(this.querySelector('.about'), 'remove', 'save');
    });

    this.querySelector('.cancel').addEventListener('click', () => {
      this._addOrRemoveEditMode(
        this.querySelector('.about'),
        'remove',
        'cancel'
      );
    });

    this.querySelector('.start-edit').addEventListener('click', e => {
      this._addOrRemoveEditMode(this.querySelector('.about'), 'add', 'edit');
    });
  }

  // eslint-disable-next-line class-methods-use-this
  _mapQlEditorKeyBindings(aboutUsEditor) {
    try {
      const aboutUsQlEditor = aboutUsEditor.querySelector('.ql-editor');

      // for resizing till 500 px
      aboutUsQlEditor.addEventListener('keyup', () => {
        autoResize(aboutUsQlEditor);
      });

      // to make sure the toolbar blur is disabled in order to avoid the left side tooltip
      if (aboutUsEditor.querySelector('.ql-toolbar')) {
        aboutUsEditor
          .querySelector('.ql-toolbar')
          .addEventListener('mousedown', e => {
            e.preventDefault();
          });
      }
    } catch (err) {
      console.error(`Exceptin while editor key binding ${err}`);
    }
  }

  _addOrRemoveEditMode(element, action, mode) {
    try {
      if (action === 'add') {
        element.classList.add('edit-mode');

        element.querySelectorAll('.editable').forEach(editable => {
          editable.classList.remove('hide');
          element.querySelector('.about-display').classList.add('hide');
          editable.querySelector('.ql-editor').innerHTML = this.querySelector(
            '.about-display'
          ).innerHTML;
        });
      } else if (action === 'remove') {
        element.classList.remove('edit-mode');
        element.querySelectorAll('.editable').forEach(editable => {
          editable.classList.add('hide');
          element.querySelector('.about-display').classList.remove('hide');
          if (mode === 'save') {
            element.querySelector(
              '.about-display'
            ).innerHTML = editable.querySelector('.ql-editor').innerHTML;
          }
        });
      }
    } catch (e) {
      console.error(
        `Error while add add or remove about us edit mode :: ${e.message}`
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async _fetchAboutUsDetails(semanticName) {
    try {
      const request = {};
      request.contentType = 'application/json; charset=utf-8';
      request.method = 'GET';
      request.url = `/api/v1/university/${semanticName}/landing/description`;

      return await ajax(request);
    } catch (e) {
      console.error(`Error while fetching about us :: ${e.message}`);
      return {};
    }
  }
}
